import React from 'react'
import Style from './Wttsep.module.css'
import wattsep from'../img/whatsapp (1).gif'

const Wttsep = () => {


    return (
        <>
            <div className={ Style.topbtn }>
                <a href="https://wa.me/919313696550"><img src={wattsep} width={ 70 } height={ 70 } alt="" /></a>

            </div>

        </>
    )
}

export default Wttsep
